import { BaseIcon, BaseIconProps } from '../../../malty/atoms/BaseIcon';
import React from 'react';

export const EyeShow = ({ dataTestId = 'icon-EyeShow', ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} dataTestId={dataTestId}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18C6.47715 18 2 12 2 12C2 12 6.47715 6 12 6C17.5228 6 22 12 22 12C22 12 17.5228 18 12 18ZM6.20526 10.5398C5.59117 11.0488 5.06282 11.5605 4.64349 12C5.06282 12.4395 5.59117 12.9512 6.20526 13.4602C7.88612 14.8535 9.93484 16 12 16C14.0652 16 16.1139 14.8535 17.7947 13.4602C18.4088 12.9512 18.9372 12.4395 19.3565 12C18.9372 11.5605 18.4088 11.0488 17.7947 10.5398C16.1139 9.14655 14.0652 8 12 8C9.93484 8 7.88612 9.14655 6.20526 10.5398ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
    />
  </BaseIcon>
);
